/* eslint id-length: [2, {"exceptions":["a","b"]}] */

/**
 * Add properties to each row object so we know how to sort them
 */
import { kffIsNumber } from '../util';
import { appDefault as constants } from '../../config/config';

export function buildRowProperties(value) {
  const props = {};
  const val = value !== 0 && !value ? '' : value.toString();
  const hasWords = /([a-z\s].*?\s?){1,}/i;
  const numberVal = val.toString()
    .replace(/[^0-9-\.]/g, '');
  props.isTerritory = constants.kffTerritories.indexOf(val) !== -1;
  props.isStateCategory = constants.isStateCategory.test(val);
  props.isSpecialGeo = constants.isSpecialGeo.test(val);
  props.wrapup = constants.specialWrapups.indexOf(val) > -1;
  props.isSummary = constants.isSummaryRow.test(val.toString());
  props.naData = constants.dataNotAvailable.indexOf(val) > -1;
  props.rawValue = kffIsNumber(numberVal) &&
    !hasWords.test(value) ?
      +numberVal :
      false;

  if (props.isSummary) {
    props.value = val.replace(/\s+\(All\)$/, '');
  } else {
    props.value = val;
  }

  return props;
}

export function sortArbitrary(a, b, order, isInverted = false) {
  const aForceSortIndex = order.indexOf(a);
  const bForceSortIndex = order.indexOf(b);
  if (aForceSortIndex && bForceSortIndex &&
      aForceSortIndex !== bForceSortIndex) {
    return (isInverted ? -1 : 1) *
      (aForceSortIndex > bForceSortIndex ? 1 : -1);
  } else if (aForceSortIndex) {
    return 1;
  } else if (bForceSortIndex) {
    return -1;
  }
  return false;
}



// WEBPACK FOOTER //
// ../datacenter/app/js/util/sorters/util.js